export default __webpack_public_path__ + "static/media/lemontbotanique_background_m1.1ad8a045.jpg";